(function () {
  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function getSelectedValues(root, selector) {
    return qsa(selector, root)
      .filter(el => el.checked)
      .map(el => (el.value || '').trim())
      .filter(Boolean);
  }

  function normalizeList(str) {
    return (str || '')
      .split(',')
      .map(s => s.trim())
      .filter(Boolean);
  }

  function itemMatches(item, selectedColors, selectedSizes) {
    const itemColors = normalizeList(item.getAttribute('data-colors'));
    const itemSizes = normalizeList(item.getAttribute('data-sizes'));


    const colorOK = selectedColors.length === 0
      || selectedColors.some(c => itemColors.includes(c));


    const sizeOK = selectedSizes.length === 0
      || selectedSizes.some(s => itemSizes.includes(s));

    return colorOK && sizeOK;
  }

  function applyFilters(scope) {
    const selectedColors = getSelectedValues(scope, '[data-filter-color]');
    const selectedSizes = getSelectedValues(scope, '[data-filter-size]');

    const items = qsa('[data-color-item]', scope);
    let visibleCount = 0;

    items.forEach(item => {
      const ok = itemMatches(item, selectedColors, selectedSizes);
      item.style.display = ok ? '' : 'none';
      if (ok) visibleCount++;
    });

    const empty = qs('[data-filter-empty]', scope);
    if (empty) empty.style.display = visibleCount === 0 ? '' : 'none';


    const table = qs('[data-size-table]');
    if (table) {
      const rows = qsa('[data-size-row]', table);


      if (selectedSizes.length === 0) {
        rows.forEach(r => r.style.display = '');
      } else {
        rows.forEach(r => {
          const sizeLabelEl = qs('.size', r) || qs('[data-size]', r);
          const label = (sizeLabelEl ? sizeLabelEl.textContent : r.textContent).trim();
          const ok = selectedSizes.some(s => label.includes(s));
          r.style.display = ok ? '' : 'none';
        });
      }
    }
  }


  function interceptSwatchClick(e) {
    const a = e.target.closest('[data-color-link]');
    if (!a) return;

    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (typeof e.button !== 'undefined' && e.button !== 0) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    const url = a.getAttribute('data-color-url') || a.getAttribute('href');
    if (!url) return;


    swapSizeTable(url, a);
  }

  async function swapSizeTable(url, clickedEl) {
    try {
      const res = await fetch(url, { credentials: 'same-origin' });
      if (!res.ok) throw new Error('fetch failed');
      const html = await res.text();

      const doc = new DOMParser().parseFromString(html, 'text/html');


      const nextTable = doc.querySelector('[data-size-table]');
      if (!nextTable) {
        window.location.href = url;
        return;
      }

      const curTable = document.querySelector('[data-size-table]');
      if (curTable) curTable.replaceWith(nextTable);


      document.querySelectorAll('.item-colortip--active').forEach(el => el.classList.remove('item-colortip--active'));
      clickedEl.classList.add('item-colortip--active');


      const scope = document.querySelector('[data-color-filter-scope]');
      if (scope) applyFilters(scope);

      nextTable.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } catch (err) {
      window.location.href = url;
    }
  }

  function bind(scope) {

    scope.addEventListener('change', (e) => {
      if (
        e.target.matches('[data-filter-color]') ||
        e.target.matches('[data-filter-size]')
      ) {
        applyFilters(scope);
      }
    });

    // クリア
    const clearBtn = qs('[data-filter-clear]', scope);
    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        qsa('[data-filter-color], [data-filter-size]', scope).forEach(el => el.checked = false);
        applyFilters(scope);
      });
    }

    // 初回
    applyFilters(scope);
  }

  // 初期化
  document.addEventListener('click', interceptSwatchClick, true);
  document.addEventListener('pointerdown', interceptSwatchClick, true);

  const scope = document.querySelector('[data-color-filter-scope]');
  if (scope) bind(scope);
})();
